import { ShenghuiRequest } from './shenghuiRequest';
import { BillingParameter, partsFormType, offerTemporaryTemporary, appointmentParameter, storeDetailParameter, storeDetail, addStoreParameter } from "@/assets/types/common";
import { LocationQueryValue } from 'vue-router';

// ==================== newCustomer 专用 API 函数（使用 shenghui 域名） ====================

// 权限列表
const permissionList = (data: { type: number, role_name: string }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/Admin/permissionList',
        data
    })
}

// 基本设置--列表（不分页）
const getBasicsetTotalList = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/Basicset/totalList',
        data
    })
}

// 服务类型、合作方、保险公司列表
const getOrderCarSelectList = () => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/OrderCar/get',
        data: {}
    })
}

// 车辆信息
const getCarInfoDetail = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/Car/info',
        data
    })
}

// 车辆信息修改
const editCarInfoDetail = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/Car/editCarInfo',
        data
    })
}

// 所属单位
const getOrderCarRepairunit = (data: { search?: string }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/OrderCar/repairunit',
        data
    })
}

// 品牌车型
const getCarBrand = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/OrderCar/carBrand',
        data
    })
}

// 施工部门、员工
const getConstructors = (data: { type?: number }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/OrderCar/constructors',
        data
    })
}

// 施工部门、员工（胜辉专用）
const getConstructorsShenghui = (data: { type?: number }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/OrderCar/constructorsShenghui',
        data
    })
}

// 接车订单详情
const getOrderCarInfo = (data: { order_id: string | null | number | LocationQueryValue[] }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/OrderCar/info',
        data
    })
}

// 获取订单支付二维码
const getPayQrcode = (data: { order_id: string | null | number | LocationQueryValue[] }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/OrderCar/getPayQrcode',
        data
    })
}

// 接车详情
const getReceivingCar = (data: { order_id: string | null | LocationQueryValue[] }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/OrderCar/getreceivingcar',
        data
    })
}

// 修改接车详情
const postEditReceivingCar = (data: any) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/OrderCar/editreceivingcar',
        data
    })
}

//车辆信息
const getCarOne = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/getCarOne',
        data
    })
}

//车辆管理导出
const carManageExport = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/carManageExport',
        data
    })
}

//新增车辆
const addCarInfo = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/Car/addCarInfo',
        data
    })
}

//到期提醒导出
const carDueExport = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/carDueExport',
        data
    })
}

//车辆产值排行导出
const carRankExport = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/carRankExport',
        data
    })
}

// 工单详情
const getOrderCarOrderinfo = (data: { order_id: number }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/OrderCar/orderinfo',
        data
    })
}

// 获取VIN信息
const getVinInfo = (data: { vin: string }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/Ocr/getVinInfo',
        data
    })
}

// 配件施工明细导出
const partsConstructionExport = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/ConstructionOrder/partsConstructionExport',
        data
    })
}

//采购列表
const getPurchaseTable = (data: { page: number, pagesize: number, time_type?: string, start_time?: string, end_time?: string, purchase_type: string, status?: number | string, supplier_id?: number | string, employee_id: number | string, search: string }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/Purchase/list',
        data
    })
}

//获取供应商列表
const getSupplierList = (data: { page?: number, pagesize?: number, status?: number, search?: number }) => {
    return ShenghuiRequest.axiosInstance({
        url: "adminapi/supplier/list",
        data
    })
}

//查询回访详情
const getBackVisitInfo = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/BackVisit/getBackVisitInfo',
        data
    })
}

//回访登记
const createBackVisit = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/BackVisit/createBackVisit',
        data
    })
}

//编辑回访详情
const editBackVisit = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/BackVisit/editBackVisit',
        data
    })
}

//待办列表
const scheduleIndex = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/Schedule/index',
        data
    })
}

//待办类型
const scheduleTypeListAPi = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/Schedule/getTypeList',
        data
    })
}

// 车辆管理列表
const carManageList = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/carManageList',
        data
    })
}

// 删除订单车辆用户
const delCarUser = (data: { order_id: number, type?: number }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/Order/delCarUser',
        data
    })
}

// 车辆活跃状况
const carLiveness = (data?: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/car/liveness',
        data: data || {}
    })
}

// 服务记录列表
const serveRecord = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/serveRecord',
        data
    })
}

// 标记已跟进
const markFollowed = (data: { id: number }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/markFollowed',
        data
    })
}

// 客户回访-工单列表
const orderList = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/orderList',
        data
    })
}

// 到期提醒列表V2
const carDueList = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/carDueV2',
        data
    })
}

// 到期提醒处理V2
const carDueDeal = (data: { id: number, remark?: string }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/carDueDealV2',
        data
    })
}

// 项目列表
const getProjectList = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/Project/list',
        data
    })
}

// 车辆产值排行V2
const carRankList = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/carRankV2',
        data
    })
}

// 添加出单
const addWolfOrder = (data: any) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/addWolfOrder',
        data
    })
}

// 添加报价/跟进/战败
const addQuotation = (data: { data_id: number, o_id?: number, remark: string, type: number }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/addQuotation',
        data
    })
}

// 统计报表
const totalSj = (data: { start_time: string, end_time: string, page?: number, pagesize?: number }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/totalSj',
        data
    })
}

// 获客数据统计
const onlineSalesStat = (data: { start_time?: string, end_time?: string, admin_id?: string | number }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/OrderCar/onlineSalesStat',
        data
    })
}

// 战败订单列表
const defeatList = (data: { page: number, limit?: number, car_brand_id?: number | string, car_series_id?: number | string, date?: any, search?: string }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/OrderCar/defeat_list',
        data
    })
}

// 恢复战败工单
const recoverDefeatOrder = (data: { id: number }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/OrderCar/recover',
        data
    })
}

// 战败恢复（带原因）
const defeatRecover = (data: { id: number, reason: string }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/OrderCar/defeatRecover',
        data
    })
}

// 战败记录列表
const zhanbaiList = (data: { start_time?: number, end_time?: number, page?: number, pagesize?: number, o_id?: string, car_code?: string }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/zhanbaiList',
        data
    })
}

// 跟进记录列表
const genjinList = (data: { start_time?: number, end_time?: number, page?: number, pagesize?: number, o_id?: string, car_code?: string, data_id?: number, maturity_type?: number | string }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/genjinList',
        data
    })
}

// 保单列表
const bdList = (data: { start_time?: number, end_time?: number, page?: number, pagesize?: number }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/bdList',
        data
    })
}

// 审核保单（通过/不通过）
const checkBd = (data: { id: number, status: number }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/checkBd',
        data
    })
}

// 保单详情
const bdInfo = (data: { id: number }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/bdInfo',
        data
    })
}

// 菜单列表
const menuList = (data: {}) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/Privilege/menuList',
        data
    })
}

// 保险公司金额占比统计
const bxgsStat = (data: any) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/bxgsStat',
        data
    })
}

// 达成率折线图
const bxgsStatRate = (data: any) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/bxgsStatRate',
        data
    })
}

// 业务员业绩占比统计
const ywyStat = (data: any) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/ywyStat',
        data
    })
}

// 业绩目标列表
const targetList = (data: any) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/targetList',
        data
    })
}

// 前台收银-工单战败
const defeatOrder = (data: { id: number, reason: string }) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/OrderCar/defeat',
        data
    })
}

// 新增/编辑业绩目标
const addWolfTarget = (data: any) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/addWolfTarget',
        data
    })
}

// 删除业绩目标
const delTarget = (data: any) => {
    return ShenghuiRequest.axiosInstance({
        url: 'adminapi/CustomerService/delTarget',
        data
    })
}

export {
    permissionList,
    getBasicsetTotalList,
    getOrderCarSelectList,
    getCarInfoDetail,
    editCarInfoDetail,
    getOrderCarRepairunit,
    getCarBrand,
    getConstructors,
    getConstructorsShenghui,
    getOrderCarInfo,
    getPayQrcode,
    getReceivingCar,
    postEditReceivingCar,
    getCarOne,
    carManageExport,
    addCarInfo,
    carDueExport,
    carRankExport,
    getOrderCarOrderinfo,
    getVinInfo,
    partsConstructionExport,
    getPurchaseTable,
    getSupplierList,
    getBackVisitInfo,
    createBackVisit,
    editBackVisit,
    scheduleIndex,
    scheduleTypeListAPi,
    carManageList,
    delCarUser,
    carLiveness,
    serveRecord,
    markFollowed,
    orderList,
    carDueList,
    carDueDeal,
    getProjectList,
    carRankList,
    menuList,
    checkBd,
    bdInfo,
    bdList,
    genjinList,
    zhanbaiList,
    totalSj,
    onlineSalesStat,
    defeatList,
    recoverDefeatOrder,
    defeatRecover,
    addQuotation,
    addWolfOrder,
    targetList,
    addWolfTarget,
    delTarget,
    bxgsStat,
    ywyStat,
    bxgsStatRate,
    defeatOrder,
}
